import { devices } from '../../config/theme'
import { hidden, block, padding0 } from '../../utils/jss-utils'

const style = {}

style.base = {
  ...padding0,
  zIndex: '2',
  paddingRight: '19px',
  transform: 'scale(.55)',
  '&:active': {
    backgroundColor: 'white !important'
  },
  backgroundColor: 'white !important',
  '& button': {
    '&:active': {
      backgroundColor: 'white !important'
    },
    backgroundColor: 'white !important'
  }
}

style.base[devices.mobile] = { ...block }
style.base[devices.desktop] = { ...hidden }

export default style
